import { render, staticRenderFns } from "./inmueble-datos.vue?vue&type=template&id=4d363c48&"
import script from "./inmueble-datos.vue?vue&type=script&lang=js&"
export * from "./inmueble-datos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports